export default {
  label: "Projekte",
  deleteProject: "Projekt löschen",
  deleteProjectErrorMessage:
    "Dieses Projekt kann nicht gelöscht werden, da ein oder mehrere Anlagen für das Projekt existieren. Bitte weisen sie diese zunächst einem anderen Projekt zu.",
  deleteProjectMessage: "Möchten Sie das Projekt wirklich löschen?",
};
